import { styled } from '@linaria/react';

import { layout, space } from '../../theme/tokens';

export const Wrapper = styled.div<{ $inset?: boolean; $desktopHidden?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  padding: ${({ $inset }) =>
    $inset ? `${space['space-800']} ${space['space-600']} 0` : `0 0 ${space['space-600']}`};

  @media (min-width: ${layout.desktopBreakpoint}) {
    padding: ${({ $inset }) =>
      $inset ? `${space['space-1000']} ${space['space-1000']} 0` : `0 0 ${space['space-600']}`};
    display: ${({ $desktopHidden }) => ($desktopHidden ? 'none' : 'block')};
  }
`;
